import { useContext, useCallback } from "react";
import { RootStoreContext } from "src/stores/RootStore";
import { useMutation } from "@apollo/client";
import { UPSERT_USERSETTING } from "src/api/customer";
import { UpsertUsersetting, UpsertUsersettingVariables } from "src/api/generated/UpsertUsersetting";
import { ums_usersettings_insert_input } from "src/api/generated/globalTypes";

export const useSidebarFunctions = () => {
    const { uiSidebarStore } = useContext(RootStoreContext);

    const [upsertUsersettingSidebarMutation] = useMutation<UpsertUsersetting, UpsertUsersettingVariables>(
        UPSERT_USERSETTING
    );

    const upsertUsersettingSidebar = useCallback(
        (isSidebarCollapsed: boolean) => {
            const upsertAssemblyUserAuditObject: ums_usersettings_insert_input[] = [
                {
                    value: isSidebarCollapsed.toString(),
                    valuetype: 1,
                    key: "PORTAL.IS_SIDEBAR_COLLAPSED"
                }
            ];

            upsertUsersettingSidebarMutation({
                variables: {
                    objects: upsertAssemblyUserAuditObject
                }
            });
        },
        [upsertUsersettingSidebarMutation]
    );

    const expandSidebar = useCallback(() => {
        uiSidebarStore.expandSidebar();
        upsertUsersettingSidebar(false);
    }, [uiSidebarStore, upsertUsersettingSidebar]);

    const collapseSidebar = useCallback(() => {
        uiSidebarStore.collapseSidebar();
        upsertUsersettingSidebar(true);
    }, [uiSidebarStore, upsertUsersettingSidebar]);

    return {
        expandSidebar,
        collapseSidebar,
        upsertUsersettingSidebar
    };
};
